export const DEALS_COUNTRIES = ['NO', 'AU', 'GB', 'SE', 'US'];
export const BC_ONLY_DEAL_COUNTRIES = ['SE', 'US'];